module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAVCAYAAAANfR1FAAAA8ElEQVRYR+3WMU4CQRjF8f83NNjbESsTEJJFa3tjR8ERuIDKRE5BZWNvo7HxBIorNfUC23kBSyt2zOBiGE+w82XnBO+X9+VlBKVPlLrYwlYzOxVhABzGDnXwJcjiF/ZuP4Gj2FF7+b93sBfgEjjQgtvCsvm4bTZyBYyApgbc33jkr7fHRaO4By5UwTxmndqhc9wBrdhxwdwv3yYdMZtnoK8KtprZE4RH4EwVbJ1ed51reNipRtiTulMsG6thVT7XYBXrxqpcVZmtbiyCkoKIQWP5h+0VBX4Vk9gg//MGsCy9SYwzHtZTBSt/+A/AeeywH9YhWIv0YUJvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/vip.png
// module id = 6A7S
// module chunks = 1